// extracted by mini-css-extract-plugin
export default {"duoToneTextDefault":"DuoToneTextDefault_duoToneTextDefault__t9efh","lightText":"DuoToneTextDefault_lightText__OO4ah","darkText":"DuoToneTextDefault_darkText__vOxtw"};